var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card as KendoCard, CardActions, CardBody, CardFooter, CardHeader, CardImage, CardSubtitle, CardTitle } from '@progress/kendo-react-layout';
var StyledCard = styled(KendoCard)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-width: 1px;\n    box-shadow: none;\n\n    &.k-card-horizontal {\n        .k-card-header {\n            border-width: 0 1px 0 0;\n        }\n    }\n"])));

/**
 * The Card component represents any type of content and all kind of actions about a single subject.
 */
var Card = props => /*#__PURE__*/React.createElement(StyledCard, props);
Card.defaultProps = {
  children: undefined,
  className: undefined,
  dir: undefined,
  orientation: 'vertical',
  style: undefined,
  type: 'default'
};
Card.propTypes = {
  /**
   * Sets the Card children elements.
   */
  children: PropTypes.node,
  /**
   * Add additional classes to the Card.
   */
  className: PropTypes.string,
  /**
   * Sets the dir of the Card.
   */
  dir: PropTypes.string,
  /**
   * Set the orientation of the Card.
   * The supported values are: 'horizontal' | 'vertical'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * Sets additional CSS styles to the Card.
   */
  style: PropTypes.shape({}),
  /**
   * Set the type of the Card.
   * The supported values are: 'default' | 'primary' | 'info' | 'success' | 'warning' | 'error'
   */
  type: PropTypes.oneOf(['default', 'primary', 'info', 'success', 'warning', 'error'])
};
export default Card;
export { CardActions, CardBody, CardFooter, CardHeader, CardImage, CardSubtitle, CardTitle };